// Reusable trial details component showing pricing after free trial
import { CountryStripePriceInfo } from "@/src/features/pricing/types";
import { formatCurrency } from "@/src/utils/formatCurrency";

interface TrialDetailsProps {
  selectedPlan?: {
    price: CountryStripePriceInfo;
    planType: "yearly" | "monthly";
  } | null;
  defaultPrice?: CountryStripePriceInfo;
}

export const TrialDetails = ({
  selectedPlan,
  defaultPrice,
}: TrialDetailsProps) => {
  const plan = selectedPlan || {
    price: defaultPrice!,
    planType: "yearly" as "yearly" | "monthly",
  };

  if (!plan.price) {
    return null;
  }

  const getPricingText = () => {
    if (plan.planType === "yearly") {
      const yearlyAmount = plan.price.unit_amount ?? 0;
      const monthlyEquivalent = Math.round(yearlyAmount / 12);
      return `${formatCurrency(
        yearlyAmount,
        plan.price.currency
      )}/yr (${formatCurrency(monthlyEquivalent, plan.price.currency)}/mo)`;
    } else {
      return `${formatCurrency(
        plan.price.unit_amount ?? 0,
        plan.price.currency
      )}/mo`;
    }
  };

  return (
    <div className="text-center font-body text-sm text-zinc-600">
      <p>7 days free, then {getPricingText()}</p>
    </div>
  );
};
